import notificationClient from './notification-client';

// ─── Inbox (sino de notificações do cabeçalho) ─────────────────────────────────

export type InboxNotificationStatus = 'SENT' | 'PENDING' | 'FAILED';

export interface InboxNotification {
    id: number;
    project_id: number;
    // O backend devolve os dois como `?? null`: notificacao pode existir sem projeto
    // resolvido (project_id e' nullable em notifications_log) e sem dominio.
    project_name: string | null;
    domain_url: string | null;
    log_message: string;
    status: InboxNotificationStatus;
    created_at: string;
    sent_at: string | null;
    is_read: boolean;
}

export interface GetNotificationInboxParams {
    limit?: number;
    onlyUnread?: boolean;
}

export const getNotificationInbox = async (
    params: GetNotificationInboxParams = {}
): Promise<InboxNotification[]> => {
    const { limit = 20, onlyUnread = false } = params;
    const { data } = await notificationClient.get('/notifications/inbox', {
        params: { limit, only_unread: onlyUnread },
    });
    return data;
};

export const getUnreadNotificationCount = async (): Promise<number> => {
    const { data } = await notificationClient.get('/notifications/unread-count');
    return data.count;
};

export const markNotificationAsRead = async (id: number): Promise<void> => {
    await notificationClient.post(`/notifications/${id}/read`);
};

export const markAllNotificationsAsRead = async (): Promise<void> => {
    await notificationClient.post('/notifications/read-all');
};
